import { useEffect, useRef } from 'react';
import Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';


interface ExtendedOptions extends Highcharts.Options {
    chart?: Highcharts.ChartOptions & {
      customLabel?: Highcharts.SVGElement;
    };
  }

const DonutChart = () => {
  Highcharts3D(Highcharts); // Initialize the 3D module for Highcharts
  const chartContainer = useRef(null);

  useEffect(() => {

    if (!chartContainer.current) return;
    // Chart configuration
    const options:ExtendedOptions= {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        events: {
          render(this: Highcharts.Chart) {
            const chart = this;
            const series = chart.series[0];
            let customLabel:any;

            if (!customLabel) {
              customLabel  = 
                chart.renderer
                  .label(
                    'Total Amount<br/>' + '<strong>100</strong>',
                    0,
                    0,
                    'html'
                  )
                  .css({
                    color: '#000',
                    textAnchor: 'middle',
                  })
                  .add();
            }

            const x = series.center[0] + chart.plotLeft;
            const y =
              series.center[1] + chart.plotTop - customLabel.attr('height') / 2;

            customLabel.attr({ x, y });

            // Set font size based on chart diameter
            customLabel.css({
              fontSize: `${series.center[2] / 12}px`,
            });
          },
        },
       
      },
      title: {
        text: '',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.0f}</b>',
        shape:'callout'
      },
      plotOptions: {
        pie: {
          innerSize: '50%',
          depth: 45,
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.name}: {point.percentage:.0f}',
          },
          showInLegend: false,
        },
      },
      series: [
        {
          type: 'pie',
          name: '',
          innerSize: '75%', // Donut chart setting
          data: [
            { name: 'credited Amount', y: 60 },
            { name: 'Denial Amount', y: 40 },
            
          ],
        },
      ],
      credits: {
        enabled: false, // Disable the Highcharts watermark
      },
    };

    // Create the chart and attach it to the container
    const chart = Highcharts.chart(chartContainer.current, options) as Highcharts.Chart;

    // Cleanup when the component unmounts
    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, []);

  return (
    <div>
      {/* The container where Highcharts will render */}
      <div ref={chartContainer} style={{ height: '400px', width: '100%' }} />
    </div>
  );
};

export default DonutChart;
